/**
 * Parses the redirect from the eident provider after a verification attempt.
 */
export function isEidentCancellation(search: string): boolean {
    const params = new URLSearchParams(search);
    return params.get('code') === 'cancel';
}
